(() => {
  const carousels = document.querySelectorAll('[data-image-carousel]');
  if (!carousels.length) return;

  carousels.forEach((carousel) => {
    const speed = Number(carousel.dataset.speed);
    const track = carousel.querySelector('.image-carousel__track');
    if (!track) return;

    const safeSpeed = Number.isFinite(speed) && speed > 0 ? speed : 28;
    track.style.setProperty('--image-carousel-duration', `${safeSpeed}s`);
  });
})();
